import { render, staticRenderFns } from "./FAQManage.vue?vue&type=template&id=1b60b93f&scoped=true&"
import script from "./FAQManage.vue?vue&type=script&lang=js&"
export * from "./FAQManage.vue?vue&type=script&lang=js&"
import style0 from "./FAQManage.vue?vue&type=style&index=0&id=1b60b93f&scoped=true&lang=css&"
import style1 from "./FAQManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60b93f",
  null
  
)

export default component.exports